import {
	Avatar,
	Box,
	Button,
	Divider,
	Hidden,
	lighten,
	List,
	ListItem,
	ListItemText,
	Popover,
	Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

import AccountBoxTwoToneIcon from "@mui/icons-material/AccountBoxTwoTone";
import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
import LockOpenTwoToneIcon from "@mui/icons-material/LockOpenTwoTone";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "src/components/Context/AuthContext/AuthContext";
import { Iuser } from "src/components/Context/AuthContext/AuthTypes";
import { AUTH_USER_FAILED, imgUrl } from "src/Helpers/utils/constants";
const UserBoxButton = styled(Button)(
	({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
	({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
	({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
	({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
	({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
	const { user: authUser, dispatch: authDispatch } = useAuthContext();

	const [user, setUser] = useState<Iuser>({});
	const navigate = useNavigate();

	useEffect(() => {
		setUser(authUser);
	}, [authUser]);

	const avatar = "/static/images/avatars/1.jpg";
	const ref = useRef<any>(null);
	const [isOpen, setOpen] = useState<boolean>(false);
	const [notificationOpen, setNotificationOpen] = useState<boolean>(false);

	const handleOpen = (): void => {
		setOpen(true);
	};

	const handleClose = (): void => {
		setOpen(false);
	};

	const handleSignOut = () => {
		localStorage.removeItem("admin_auth");
		authDispatch?.({
			type: AUTH_USER_FAILED,
		});

		navigate("/login");
	};

	const handleNotificationOpen = () => {
		setNotificationOpen(true);
	};
	const handleNotificationClose = () => {
		setNotificationOpen(false);
	};
	const notificationCount = 5;
	return (
		<>
			<UserBoxButton
				color='secondary'
				ref={ref}
				onClick={handleOpen}
				sx={{ minWidth: 0, p: { xs: 0.3, sm: 1 } }}
			>
				<Avatar
					variant='rounded'
					alt={user.user_admin_name}
					src={
						user.user_admin_photo
							? `${imgUrl}/admin_files/${user.user_admin_photo}`
							: ""
					}
					sx={{ width: { xs: 32, sm: 38 }, height: { xs: 32, sm: 38 } }}
				/>

				<Hidden mdDown>
					<UserBoxText>
						<UserBoxLabel variant='body1'>
							{user?.user_admin_name}
						</UserBoxLabel>
					</UserBoxText>
				</Hidden>
				<Hidden smDown>
					<ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
				</Hidden>
			</UserBoxButton>

			<Popover
				anchorEl={ref.current}
				onClose={handleClose}
				open={isOpen}
				anchorOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "right",
				}}
			>
				<MenuUserBox sx={{ minWidth: 210 }} display='flex'>
					<Avatar
						variant='rounded'
						alt={user.user_admin_name}
						src={
							user.user_admin_photo
								? `${imgUrl}/admin_files/${user.user_admin_photo}`
								: ""
						}
					/>
					<UserBoxText>
						<UserBoxLabel variant='body1'>
							{user.user_admin_name}
						</UserBoxLabel>
						{/* <UserBoxDescription variant='body2'>
              {user.jobtitle}
            </UserBoxDescription> */}
					</UserBoxText>
				</MenuUserBox>
				<Divider sx={{ mb: 0 }} />
				<List sx={{ p: 1 }} component='nav'>
					<ListItem button to='/profile/details' component={NavLink}>
						<AccountBoxTwoToneIcon fontSize='small' />
						<ListItemText primary='My Profile' />
					</ListItem>
				</List>
				<Divider />
				<Box sx={{ m: 1 }}>
					<Button
						onClick={() => handleSignOut()}
						color='error'
						fullWidth
						sx={{
							justifyContent: "flex-start",
							textAlign: "left",
							pl: 2.3,
						}}
					>
						<LockOpenTwoToneIcon sx={{ mr: 0.5 }} />
						Sign out
					</Button>
				</Box>
			</Popover>
		</>
	);
}

export default HeaderUserbox;
